import { Injectable } from '@angular/core';
import { CookieBarState } from '../../app/classes/static/enums';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class IBankCookieService {
	private _state = new BehaviorSubject<CookieBarState>(CookieBarState.visible);
	public state$ = this._state.asObservable();

	private _acceptedCookies = new BehaviorSubject<string[]>([]);
	public acceptedCookies$ = this._acceptedCookies.asObservable();

	constructor() {}

	public hide(): void {
		this._state.next(CookieBarState.hidden);
	}

	public show(): void {
		this._state.next(CookieBarState.visible);
	}

	public acceptAll(): void {
		this.hide();
	}

	public rejectAll(): void {
		this.hide();
	}

	public manage(): void {
		this.hide();
	}
}
